import React from "react";

export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <h1>Customer Testimonials</h1>
          <p>Real feedback from property owners we have served in and around Clinton, NC.</p>
          <p className="testimonials-google-rating">
            Rated <strong>5.0 out of 5</strong> across{" "}
            <strong>42 Google reviews</strong>.{" "}
            <a
              href="https://www.google.com/maps/place/Hamilton+Pressure+Washing/@34.9860918,-78.387517,15z/data=!4m6!3m5!1s0x89abbd0f994c6981:0x398858a7c39e099c!8m2!3d34.9860918!4d-78.387517!16s%2Fg%2F11rb5_9277?entry=ttu"
              target="_blank"
              rel="noopener noreferrer"
            >
              Read them on Google
            </a>
          </p>
        </div>
        <div className="testimonials-grid">
          {props.data
            ? props.data.map((d, i) => (
                <article key={`${d.name}-${i}`} className="testimonial">
                  <span className="testimonial-quote-mark" aria-hidden="true">
                    “
                  </span>
                  <div className="testimonial-content">
                    <p>{d.text}</p>
                  </div>
                  <div className="testimonial-meta">{d.name}</div>
                </article>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
